import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { OverlayView } from '@react-google-maps/api';

class GoogleMarkerWrapper extends Component {
  render() {
    const { position, children, zIndex } = this.props;
    const { lat, lng } = position;

    if (lat === undefined || lat === null || lng === undefined || lng === null) return null;

    return (
      <OverlayView
        position={{ lat, lng }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
        getPixelPositionOffset={(width, height) => ({
          x: -(width / 2),
          y: -height,
        })}
      >
        <div class="pin" style={{ zIndex, position: 'relative', display: 'inline-block' }}>
          {children}
        </div>
      </OverlayView>
    );
  }
}

GoogleMarkerWrapper.propTypes = {
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  children: PropTypes.node.isRequired,
  zIndex: PropTypes.number,
};

GoogleMarkerWrapper.defaultProps = {
  zIndex: 0,
};

export default GoogleMarkerWrapper;
